import {
    EntityAdapter,
    EntityState as ngEntityState,
    createEntityAdapter, EntityState,
} from "@ngrx/entity";
import {Chat, Message, Participant} from "./chat.model";

export const chatAdapter = createEntityAdapter<Chat>({
    selectId: c => c.id
});

export const messageAdapter = createEntityAdapter<Message>({
    selectId: m => m.id
});


export const participantAdapter = createEntityAdapter<Participant>({
    selectId: m => m.id
});


export interface ChatState {
    chats: EntityState<Chat>;
    messages: EntityState<Message>;
    participants: EntityState<Participant>;
}

export const initialChatState: ChatState = {
    chats: chatAdapter.getInitialState(),
    messages: messageAdapter.getInitialState(),
    participants: participantAdapter.getInitialState(),
};

